import { useLazyQuery } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { gql } from '@/__generated__';

type TestFilterInput = {
  prompt: string;
};

const TEST_AI_FILTER = gql(`
  query TestAIFilter($filter: AIFilterTestInput!, $text: String!) {
    aiFilterTest(filter: $filter, text: $text)
  }
`);

export const useTestAiFilter = (filter: TestFilterInput, text?: string) => {
  const toast = useToast();
  const [testFilter, { data, loading, error, variables }] = useLazyQuery(
    TEST_AI_FILTER,
    {
      onError: (error) => {
        toast.error({
          title: 'Error testing AI filter',
          subTitle: error?.message || 'Please try again',
        });
      },
    },
  );

  const runTest = () => {
    testFilter({
      variables: {
        filter,
        text: text || '',
      },
    });
  };

  return {
    testFilter: runTest,
    result:
      !loading &&
      !error &&
      variables?.filter?.prompt === filter.prompt &&
      variables?.text === (text || '')
        ? data?.aiFilterTest
        : undefined,
    loading,
    error,
  };
};
